import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { AccountApiService } from '@shared/service/account-api.service';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { RegistrationActions } from '@shared/store/registration/registration.actions';

export interface RegistrationStateModel {
  startRegistrationData;
}

@State<RegistrationStateModel>({
  name: 'registration'
})
@Injectable()
export class RegistrationState {
  constructor(private readonly accountApiService: AccountApiService,
              private readonly router: Router) {
  }

  @Action(RegistrationActions.StartRegistration)
  async saveToken(ctx: StateContext<RegistrationStateModel>, payload: RegistrationActions.StartRegistration) {
    await firstValueFrom(this.accountApiService.startRegistration(payload.registrationData));
    ctx.patchState({
      startRegistrationData: payload.registrationData
    });
    this.router.navigate([ 'auth', 'registration-complete' ], {
      queryParams: {
        email: payload.registrationData.email
      }
    });
  }
}


